'use client'
import { ContainerCustom } from '@/components/common/container-custom'
import { HOME_SPACING_SECTION } from '@/constants/layout'
import { useProducts } from '@/features/products'
import { Box, Grid, Stack, Typography } from '@mui/material'
import StylingItem from '../../home/components/styling-item'

export default function SectionStyling() {
  const apiParams = {
    pageSize: 999,
    currentPage: 1,
  }
  const { data: products } = useProducts(apiParams)
  return (
    <ContainerCustom component={'div'}>
      <Box
        sx={{
          py: HOME_SPACING_SECTION,
        }}
      >
        <Stack
          direction="row"
          sx={{
            mb: 4,
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
          spacing={{ xs: 1, sm: 2 }}
        >
          <Box sx={{ width: '100%', textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: {
                  xs: '1.8rem',
                  md: '2rem',
                  lg: '3rem',
                },
                fontWeight: 700,
              }}
            >
              STYLING
            </Typography>
            <Typography
              sx={{
                fontSize: '0.875rem',
                mt: 1,
              }}
            >
              Tham khảo ngay các kiểu dáng phối đồ
              <br />
              mà chúng tôi làm ra dành riêng cho các bạn
            </Typography>
            {/* <Box sx={{ mt: 3, display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
              <ButtonRoundStyle
                variant="outlined"
                sx={{
                  width: 'fit-content',
                  fontSize: '0.875rem',
                  padding: '0.5rem 1rem',
                  transition: 'all .3s ease-in-out',
                  borderColor: '#BBBBBA',
                  color: '#252422',
                  '&:hover': {
                    backgroundColor: '#252422',
                    color: '#fff',
                    borderColor: '#252422',
                  },
                }}
              >
                Set đồ đi làm
              </ButtonRoundStyle>
              <ButtonRoundStyle
                variant="outlined"
                sx={{
                  width: 'fit-content',
                  fontSize: '0.875rem',
                  padding: '0.5rem 1rem',
                  transition: 'all .3s ease-in-out',
                  borderColor: '#BBBBBA',
                  color: '#252422',
                  '&:hover': {
                    backgroundColor: '#252422',
                    color: '#fff',
                    borderColor: '#252422',
                  },
                }}
              >
                Set đồ hẹn hò
              </ButtonRoundStyle>
              <ButtonRoundStyle
                variant="outlined"
                sx={{
                  width: 'fit-content',
                  fontSize: '0.875rem',
                  padding: '0.5rem 1rem',
                  transition: 'all .3s ease-in-out',
                  borderColor: '#BBBBBA',
                  color: '#252422',
                  '&:hover': {
                    backgroundColor: '#252422',
                    color: '#fff',
                    borderColor: '#252422',
                  },
                }}
              >
                Set đồ đi chơi
              </ButtonRoundStyle>
            </Box> */}
          </Box>
        </Stack>
        <Grid container spacing={2} columns={12}>
          {MockupStylingItems.map((item, index) => {
            const currentProducts = products?.items?.filter((product) =>
              item.products.some((p) => p.sku === product?.sku)
            )
            return (
              <StylingItem key={index} item={item} imageMain={item.imageMain} products={currentProducts} />
            )
          })}
        </Grid>
      </Box>
    </ContainerCustom>
  )
}
const SKU_PRODUCT = {
  BOXY_LOGO: 'ao-thun-boxy-logo-hydra-basic',
  BOXY_TRON: 'ao-thun-tron-boxy',
  HYDRA_BASIC: 'ao-thun-hydra-basic-100-cotton-300gsm',
  QUAN_SHORT_JEANS: 'quan-short-Jeans-Jean-denim-nam',
  QUAN_DAI_JEANS: 'quan-dai-jeans-jean-denim-nam',
  QUAN_SHORT_KAKI: 'quan-short-kaki-jeans',
} as const
const AO_HYDRA_BASIC_TRANG = {
  sku: SKU_PRODUCT.HYDRA_BASIC,
  attributes: [
    {
      code: 'color',
      label: 'Trắng',
      uid: 'Y29uZmlndXJhYmxlLzkzLzI1',
    },
    {
      code: 'size',
      label: 'L',
      uid: 'Y29uZmlndXJhYmxlLzE2Mi8yOQ==',
    },
  ],
}
const AO_HYDRA_BASIC_DEN = {
  sku: SKU_PRODUCT.HYDRA_BASIC,
  attributes: [
    {
      code: 'color',
      label: 'Đen',
      uid: 'Y29uZmlndXJhYmxlLzkzLzI2',
    },
    {
      code: 'size',
      label: 'M',
      uid: 'Y29uZmlndXJhYmxlLzE2Mi8yOA==',
    },
  ],
}
const AO_BOXY_TRON_DEN = {
  sku: SKU_PRODUCT.BOXY_TRON,
  attributes: [
    {
      code: 'color',
      label: 'Đen',
      uid: 'Y29uZmlndXJhYmxlLzkzLzI2',
    },
    {
      code: 'size',
      label: 'XL',
      uid: 'Y29uZmlndXJhYmxlLzE2Mi8zMA==',
    },
  ],
}

const AO_BOXY_TRON_XANH = {
  sku: SKU_PRODUCT.BOXY_TRON,
  attributes: [
    {
      code: 'color',
      label: 'Xanh Pastel',
      uid: 'Y29uZmlndXJhYmxlLzkzLzQ3',
    },
    {
      code: 'size',
      label: 'M',
      uid: 'Y29uZmlndXJhYmxlLzE2Mi8yOA==',
    },
  ],
}
const AO_BOXY_TRON_NAU = {
  sku: SKU_PRODUCT.BOXY_TRON,
  attributes: [
    {
      code: 'color',
      label: 'Nâu',
      uid: 'Y29uZmlndXJhYmxlLzkzLzQz',
    },
    {
      code: 'size',
      label: 'L',
      uid: 'Y29uZmlndXJhYmxlLzE2Mi8yOQ==',
    },
  ],
}

const QUAN_SHORT_JEANS_XANH = {
  sku: SKU_PRODUCT.QUAN_SHORT_JEANS,
  attributes: [
    {
      code: 'color',
      label: 'Xanh',
      uid: 'Y29uZmlndXJhYmxlLzkzLzQ2',
    },
    {
      code: 'size',
      label: 'XL',
      uid: 'Y29uZmlndXJhYmxlLzE2Mi8zMA==',
    },
  ],
}
const QUAN_DAI_JEANS_XANH = {
  sku: SKU_PRODUCT.QUAN_DAI_JEANS,
  attributes: [
    {
      code: 'color',
      label: 'Xanh',
      uid: 'Y29uZmlndXJhYmxlLzkzLzQ2',
    },
    {
      code: 'size',
      label: 'L',
      uid: 'Y29uZmlndXJhYmxlLzE2Mi8yOQ==',
    },
  ],
}
type StyleItem = {
  title: string
  imageMain: string
  heightModel: number
  weightModel: number
  products: any[]
}

const MockupStylingItems: StyleItem[] = [
  {
    title: 'Set đồ 1',
    imageMain: '/assets/images/set-styling-1.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 2',
    imageMain: '/assets/images/set-styling-2.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_TRANG],
  },
  {
    title: 'Set đồ 3',
    imageMain: '/assets/images/set-styling-3.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_TRANG],
  },
  {
    title: 'Set đồ 4',
    imageMain: '/assets/images/set-styling-4.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 5',
    imageMain: '/assets/images/set-styling-5.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_BOXY_TRON_DEN, QUAN_DAI_JEANS_XANH],
  },
  {
    title: 'Set đồ 6',
    imageMain: '/assets/images/set-styling-6.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 7',
    imageMain: '/assets/images/set-styling-7.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_BOXY_TRON_XANH, QUAN_SHORT_JEANS_XANH],
  },
  {
    title: 'Set đồ 8',
    imageMain: '/assets/images/set-styling-8.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_TRANG],
  },
  {
    title: 'Set đồ 9',
    imageMain: '/assets/images/set-styling-9.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 10',
    imageMain: '/assets/images/set-styling-10.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 11',
    imageMain: '/assets/images/set-styling-11.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 12',
    imageMain: '/assets/images/set-styling-12.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_TRANG],
  },
  {
    title: 'Set đồ 13',
    imageMain: '/assets/images/set-styling-13.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_BOXY_TRON_NAU],
  },
  {
    title: 'Set đồ 14',
    imageMain: '/assets/images/set-styling-14.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_TRANG],
  },
  {
    title: 'Set đồ 15',
    imageMain: '/assets/images/set-styling-15.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_BOXY_TRON_DEN, QUAN_DAI_JEANS_XANH],
  },
  {
    title: 'Set đồ 16',
    imageMain: '/assets/images/set-styling-16.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_TRANG],
  },
  {
    title: 'Set đồ 17',
    imageMain: '/assets/images/set-styling-17.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 18',
    imageMain: '/assets/images/set-styling-18.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 19',
    imageMain: '/assets/images/set-styling-19.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_DEN],
  },
  {
    title: 'Set đồ 20',
    imageMain: '/assets/images/set-styling-20.jpg',
    heightModel: 175,
    weightModel: 65,
    products: [AO_HYDRA_BASIC_TRANG],
  },
]
